import { useEffect } from "react"

const defaultSuffix = `: solana address book`

export const useDocumentTitle = (title: string | null, suffix = defaultSuffix) => {
  useEffect(() => {
    if (title != null) {
      document.title = `${title}${suffix}`
    }
  }, [title, suffix])
}
